<div class="signupMainContainer">
  <form [formGroup]="signupForm" (ngSubmit)="onSubmit()" class="signupBlock">
    <img src="assets/logo.svg" width="200px" draggable="false" />
    <input
      type="text"
      id="email"
      [placeholder]="'auth.signup.email' | translate"
      formControlName="email"
      class="form-control"
      aria-label="Small"
      aria-describedby="inputGroup-sizing-sm"
      autocomplete="email"
    />
    <div class="passwordField">
      <input
        [type]="showPassword() ? 'text' : 'password'"
        id="password"
        [placeholder]="'auth.signup.password' | translate"
        formControlName="password"
        class="form-control"
        aria-label="Small"
        aria-describedby="inputGroup-sizing-sm"
        autocomplete="new-password"
      />
      <button
        type="button"
        class="passwordToggle"
        [attr.aria-label]="(showPassword() ? 'common.labels.hidePassword' : 'common.labels.showPassword') | translate"
        [attr.aria-pressed]="showPassword()"
        [attr.title]="(showPassword() ? 'common.labels.hidePassword' : 'common.labels.showPassword') | translate"
        (click)="togglePasswordVisibility()"
      >
        <i class="bi" [class.bi-eye]="!showPassword()" [class.bi-eye-slash]="showPassword()" aria-hidden="true"></i>
      </button>
    </div>
    <div class="passwordField">
      <input
        [type]="showVerifyPassword() ? 'text' : 'password'"
        id="verifyPassword"
        [placeholder]="'auth.signup.confirmPassword' | translate"
        formControlName="verifyPassword"
        class="form-control"
        aria-label="Small"
        aria-describedby="inputGroup-sizing-sm"
        autocomplete="new-password"
      />
      <button
        type="button"
        class="passwordToggle"
        [attr.aria-label]="(showVerifyPassword() ? 'common.labels.hidePassword' : 'common.labels.showPassword') | translate"
        [attr.aria-pressed]="showVerifyPassword()"
        [attr.title]="(showVerifyPassword() ? 'common.labels.hidePassword' : 'common.labels.showPassword') | translate"
        (click)="toggleVerifyPasswordVisibility()"
      >
        <i class="bi" [class.bi-eye]="!showVerifyPassword()" [class.bi-eye-slash]="showVerifyPassword()" aria-hidden="true"></i>
      </button>
    </div>
    <input
      type="text"
      id="lastname"
      [placeholder]="'auth.signup.lastName' | translate"
      formControlName="lastname"
      class="form-control"
      aria-label="Small"
      aria-describedby="inputGroup-sizing-sm"
      autocomplete="family-name"
    />
    <input
      type="text"
      id="firstname"
      [placeholder]="'auth.signup.firstName' | translate"
      formControlName="firstname"
      class="form-control"
      aria-label="Small"
      aria-describedby="inputGroup-sizing-sm"
      autocomplete="given-name"
    />
    <div class="checkbox">
      <input type="checkbox" id="legalAge" formControlName="legalAge" class="" aria-label="Small" aria-describedby="inputGroup-sizing-sm" />
      <label for="legalAge">{{ 'auth.signup.legalAge' | translate }}</label>
    </div>
    <div class="checkbox">
      <input type="checkbox" id="eulaOk" formControlName="eulaOk" class="" aria-label="Small" aria-describedby="inputGroup-sizing-sm" />
      <label for="eulaOk">
        J'accepte les
        <a [href]="currentLanguage.code === 'fr' ? '/legal/cgv.pdf' : `/legal/${currentLanguage.code}/cgv.pdf`" target="_blank">{{ 'auth.signup.cgv' | translate }}</a>
        et la
        <a [href]="currentLanguage.code === 'fr' ? '/legal/datapolicy.pdf' : `/legal/${currentLanguage.code}/datapolicy.pdf`" target="_blank">{{ 'auth.signup.dataPolicy' | translate }}</a>
      </label>
    </div>

    <button type="submit" class="formButton validate" [disabled]="signupForm.invalid">
      {{ 'auth.signup.signupButton' | translate }}
    </button>
    @if (!isSignupBeforePurchase()) {
      <button type="button" class="formButton anonymous" [disabled]="isAnonymousLoading()" (click)="onAnonymousLogin()">
        @if (isAnonymousLoading()) {
          <span>{{ 'common.labels.loading' | translate }}</span>
        } @else {
          <span>{{ 'auth.signup.anonymousButton' | translate }}</span>
        }
      </button>
      <div>
        {{ 'auth.signup.hasAccount' | translate }}
        <a [routerLink]="['/login']">{{ 'auth.signup.loginLink' | translate }}</a>
      </div>
    }
  </form>
</div>
